export enum AccountRoles {
  END_USERS = 'END_USERS',
  ADMINS = 'ADMINS',
  FAMILY_MEMBER = 'FAMILY_MEMBERS',
  FAMILY_ADMINS = 'FAMILY_ADMINS',
}
